import { useState } from "react";
import DocumentSliderModal from "../../../../../utilsComponent/DocumentSliderModal";
import { FORM_KEYS } from "../helper";

const DocumentDetails = ({ formData }) => {
    const [showSliderModal, setShowSliderModal] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [documentsToShow, setDocumentsToShow] = useState([])
    const handleViewDocs = (docs) => {
        setDocumentsToShow(docs);
        setShowSliderModal(true)
    }
    return (
        <>
            {formData[FORM_KEYS.document_ids][0].documentType ? (
                <>
                    <h6 className="">Documents</h6>
                    <hr className="m-0 p-0" />
                    <div className="row mt-3 px-2">
                        {formData[FORM_KEYS.document_ids].map(document => (
                            <><div className="document-link">
                                <span onClick={() => handleViewDocs(document.docs)}>{document.docs.length ? document.documentType?.label : ""} ({document.docs.length})</span>
                            </div>
                            </>
                        ))}
                    </div>
                </>
            ) : ""}
            {showSliderModal && (<DocumentSliderModal
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
                onClose={() => { setShowSliderModal(false); setCurrentIndex(0); setDocumentsToShow([]) }}
                documents={documentsToShow}
                show={showSliderModal}
            />)}

        </>
    );
};

export default DocumentDetails; 
